// Bunico: ürün kartında renk önizlemesi (planlar/2026-09-28-asama-1-kart-listeleme.md > Uygulama tanımları > Swatch önizlemesi; Q7).
// Swatch'lar gerçek bağlantıdır: tıklama/Enter o rengin sayfasını açar. Fareyle üzerine gelince veya klavye odağında
// kartın değişen parçaları (data-bn-part: media, head, sizes, cta) o rengin <template data-bn-for> içeriğiyle değiştirilir;
// swatch satırı sabit kalır. Gösterilen renk aria-current="true" taşır.
// Geri dönüş: fare karttan çıkınca temsilciye dönülür; ancak kartta klavye odağı (:focus-visible) varsa gösterilen renk
// korunur (odak swatch'taysa o renk; başlık/İncele'deyse görünen renk — odaklı bağlantı görünen ürüne ait kalır, R17).
// Odak kart dışına çıkınca (focusout, relatedTarget kart dışında) ve fare kartta değilse temsilciye dönülür.
// Değiştirilen parçada odak varsa (başlık/İncele) odak yeni parçadaki eşdeğer öğeye taşınır (data-bn-focus).
// Parça değişimi sırasında odaklı öğenin kaldırılmasının ürettiği focusout yok sayılır; değişim yeniden girilmez (R17).
// Dokunmatikte önizleme yoktur (yalnızca pointerType "mouse"); dokunma bağlantıyı açar.
// Filtre/sıralama/"Daha fazla göster" kartları yeniden eklediğinde connectedCallback yeniden kurar; dinleyiciler öğeye bağlıdır.
if (!customElements.get('bn-swatch-card')) {
  customElements.define('bn-swatch-card', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.rep = this.dataset.bnRep;
      this.shown = this.rep;
      this.hovering = false;
      this.original = new Map([...this.querySelectorAll(':scope [data-bn-part]')]
        .filter((el) => !el.closest('template'))
        .map((el) => [el.dataset.bnPart, el.cloneNode(true)]));

      this.addEventListener('pointerover', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovering = true;
        const swatch = event.target.closest('.bn-swatch');
        if (swatch) this.show(swatch.dataset.bnFor);
      });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        this.hovering = false;
        // Kartta klavye odağı varsa (swatch, başlık ya da İncele) gösterilen renk korunur: odaklı bağlantı her zaman
        // görünen ürüne ait kalır (R17). Swatch odaktaysa onun rengi gösterilir.
        const active = this.keyboardFocus();
        if (active) {
          const swatch = active.closest('.bn-swatch');
          if (swatch) this.show(swatch.dataset.bnFor);
          return;
        }
        this.show(this.rep);
      });
      this.addEventListener('focusin', (event) => {
        const swatch = event.target.closest('.bn-swatch');
        if (swatch && swatch.matches(':focus-visible')) this.show(swatch.dataset.bnFor);
      });
      this.addEventListener('focusout', (event) => {
        // Parça değişirken odaklı öğenin kaldırılması da focusout üretir; bu gerçek bir karttan çıkış değildir (R17).
        if (this.swapping || this.contains(event.relatedTarget) || this.hovering) return;
        this.show(this.rep);
      });
    }

    keyboardFocus() {
      const active = document.activeElement;
      return active && this.contains(active) && active.matches(':focus-visible') ? active : null;
    }

    show(id) {
      // Yeniden giriş koruması (R17): değişim sürerken gelen olaylar yeni bir değişim başlatmaz.
      if (!id || id === this.shown || this.swapping) return;
      const parts = id === this.rep ? this.original : this.templateParts(id);
      if (!parts) return;
      this.swapping = true;
      this.shown = id;
      try {
        parts.forEach((source, name) => {
          const current = this.querySelector(`[data-bn-part="${name}"]`);
          if (!current || !current.isConnected) return;
          const next = source.cloneNode(true);
          const active = document.activeElement;
          const focusKey = active && current.contains(active) ? active.dataset.bnFocus : null;
          current.replaceWith(next);
          if (focusKey) {
            // Odak yeni parçadaki eşdeğer bağlantıya taşınır (başlık → başlık, İncele → İncele).
            const target = next.dataset.bnFocus === focusKey ? next : next.querySelector(`[data-bn-focus="${focusKey}"]`);
            if (target) target.focus({ preventScroll: true });
          }
        });
        this.querySelectorAll('.bn-swatch').forEach((swatch) => {
          if (swatch.dataset.bnFor === id) swatch.setAttribute('aria-current', 'true');
          else swatch.removeAttribute('aria-current');
        });
      } finally {
        this.swapping = false;
      }
    }

    templateParts(id) {
      const template = this.querySelector(`template[data-bn-for="${id}"]`);
      if (!template) return null;
      return new Map([...template.content.querySelectorAll('[data-bn-part]')].map((el) => [el.dataset.bnPart, el]));
    }
  });
}
